<template>
  <div ref="hero" class="v2-hero" :class="[theme]">
    <div v-if="!videos.length" class="row">
      <div class="col-lg-8 col-xl-9 order-lg-1">
        <hero-video-placeholder />
      </div>
      <div class="col-lg-4 col-xl-3 order-lg-0">
        <hero-text-placeholder />
      </div>
    </div>

    <template v-else>
      <hero-item
        v-if="videos.length === 1"
        :id="`hero-0`"
        ref="video"
        :video="videos[0]"
        :cta-label="ctaLabel"
        :track-playback="trackPlayback"
      />
      <app-carousel v-else class="hero-slider" navigation-outer :theme="theme" @page-change="pageChange">
        <slide v-for="(video, i) in videos" :key="i">
          <hero-item ref="video" :video="video" :cta-label="ctaLabel" :track-playback="trackPlayback" />
        </slide>
      </app-carousel>
    </template>
  </div>
</template>

<script>
import { Slide } from "vue3-carousel";
import AppCarousel from "@/components/v2/app-carousel/index.vue";
import { amplitudeCarouselTrack } from "@/utils/amplitude";
import HeroTextPlaceholder from "@/components/v2/placeholders/hero-text-placeholder/index.vue";
import HeroVideoPlaceholder from "@/components/v2/placeholders/hero-video-placeholder/index.vue";
import HeroItem from "@/components/hero-item/index.vue";

export default {
  name: "hero",
  components: { HeroItem, HeroVideoPlaceholder, HeroTextPlaceholder, AppCarousel, Slide },
  props: {
    trackPlayback: {
      type: Boolean,
      required: false,
      default: false,
    },
    videos: {
      type: Array,
      required: true,
    },
    ctaLabel: {
      type: String,
      required: false,
      default: null,
    },
    theme: {
      type: String,
      require: false,
      default: "light",
      validator: (value) => {
        return ["dark", "light"].includes(value);
      },
    },
  },
  data() {
    return {
      resizeDelayTimer: null,
    };
  },
  methods: {
    setPaginationPosition() {
      this.$nextTick(() => {
        const pagination = this.$refs?.hero?.querySelector(".app-carousel-pagination");

        if (!pagination) {
          return;
        }

        if (!this.$refs.video || !this.videos.length) {
          return;
        }

        const el = this.$refs.video[0].$el;

        if (!el) {
          return;
        }

        const top = el.offsetHeight + 24;
        pagination.style.top = `${top}px`;
      });
    },
    onResize() {
      clearTimeout(this.resizeDelayTimer);
      this.resizeDelayTimer = setTimeout(() => {
        this.setPaginationPosition();
      }, 100);
    },
    pageChange() {
      amplitudeCarouselTrack("Hero slider");
    },
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.onResize);
  },
  mounted() {
    window.addEventListener("resize", this.onResize);

    this.$nextTick(() => {
      this.setPaginationPosition();
    });
  },
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
